import Vue from 'vue'
import Router from 'vue-router'

import page1 from '../components/Page1'
import page2 from '../components/Page2'
import page3 from '../components/Page3'

Vue.use(Router)

const routes = [
  {
    path: '/',
    name: 'page1',
    component: page1
  },
  {
    path: '/form',
    name: 'page2',
    component: page2
  },
  {
    path: '/thanks',
    name: 'page3',
    component: page3
  }
]

export default new Router({
  mode: 'history',
  base: document.location.hostname=="localhost"? '': 'simulator-2-new', // BASE URL をローカルと本番サーバで分岐
  routes,
  scrollBehavior: () => {
    return { x: 0, y: 0 }
  }
})
